import { AuthRoute } from '@/system-modules/auth/v1/api/AuthRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { PinResult } from '@/contracts/system-modules/auth/dto/pin/PinResult'
import { OFFLINE_REQUEST } from '@/system-modules/auth/v1/api/v1/auth/Pin/PinRoute'
import { offlineAuthResult } from '@/system-modules/auth/v1/api/v1/auth/Register/RegisterRoute'

export class PinResultRoute extends AuthRoute<null, PinResult> {
  constructor(private readonly request: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/auth/pin/' + this.request
  }

  offline(): Promise<ApiResponse<PinResult>> {
    if (this.request !== OFFLINE_REQUEST) {
      return Promise.resolve(new ApiResponse({ success: true, data: new PinResult({ status: 'pending' }) }))
    }

    return Promise.resolve(new ApiResponse({ success: true, data: new PinResult({ status: 'confirmed', ...offlineAuthResult() }) }))
  }
}
